<script>
	import axios from 'redaxios'
	import Modal from '../modal.svelte'

	export let fields = []

	let { stories } = fields

	let windowWidth, name, email, showModal

	let disableForm
	let signupUnsuccessful

	// $: moveLink = windowWidth < 1666
	$: responsive = windowWidth < 1051

	function submit(e) {
		e.preventDefault()

		if (!name || !email) {
			alert('Please fill out both fields')
			return
		}
		if (!~name.indexOf(' ')) {
			alert('Please enter a first and last name')
			return
		}
		let names = name.split(' ')

		let firstName = names.shift()
		let lastName = names.join(' ')

		disableForm = true

		// send to backend
		axios
			.post('/wp-json/boost/v1/cc-form', {
				action: 'cc_signup_form',
				email,
				firstName,
				lastName,
			})
			.then(response => {
				let data = JSON.parse(response.data)
				if (!data.contact_id) {
					signupUnsuccessful = true
				}
			})
			.catch(error => {
				// console.log('error', error)
				signupUnsuccessful = true
			})
			.then(() => {
				showModal = true
			})
	}

	function moveModalToBody(node) {
		node.parentNode.removeChild(node)
		document.body.appendChild(node)
	}
</script>

<svelte:window bind:innerWidth={windowWidth} />

{#if stories && stories.length > 1}
	<div class="news-slide-top">
		<div class="main">
			<div class="inner-wrap">

				<div class="ns-col-one">
					<h2>
						Stay up to date
						<br />
						on our latest
						<span>
							News
							<br />
							& Articles
						</span>
					</h2>
				</div>

				<div class="ns-image ns-col-two">
					{#if stories[0].img}
						<div style="background-image:url({stories[0].img})" />
					{/if}
				</div>

				<div class="ns-image ns-col-three">
					{#if stories[1].img}
						<div style="background-image:url({stories[1].img}" />
					{/if}
				</div>

			</div>
		</div>
	</div>

	<div class="news-slide-bottom">
		<div class="main">
			<div class="inner-wrap">

				<div class="ns-col-one">
					<p>
						Sign up today to receive updates on
						<br />
						Zehr Center news, articles, and blog posts. You can unsubscribe at
						any time.
					</p>
					<form
						action="/"
						class="cc-form"
						on:submit={submit}
						class:disabled={disableForm}>
						<div>
							<label for="name" class="sr-only">Full Name</label>
							<input
								bind:value={name}
								type="text"
								id="name"
								required
								maxlength="99"
								placeholder="Full Name" />
							<label for="email" class="sr-only">Email</label>
							<input
								bind:value={email}
								type="email"
								id="email"
								required
								maxlength="99"
								placeholder="Email" />
						</div>
						<button class="pointer-link" disabled={disableForm}>Sign Up</button>
					</form>
					<!-- {#if moveLink}
						<a href="/newsroom/" class="pointer-link">Newsroom</a>
					{/if} -->
					{#if responsive}
						<div class="scg">
							<div class="story-card">
								<h3>{stories[0].title}</h3>
								<div class="big-wrap">
									{@html stories[0].content}
								</div>
								<a href={stories[0].url} class="pointer-link">Read more</a>
							</div>
							<div class="story-card">
								<h3>{stories[1].title}</h3>
								<div class="big-wrap">
									{@html stories[1].content}
								</div>
								<a href={stories[1].url} class="pointer-link">Read more</a>
							</div>
						</div>
					{/if}
				</div>

				<div class="ns-col-two">
					<div class="story-card">
						<h3>{stories[0].title}</h3>
						<div class="big-wrap">
							{@html stories[0].content}
						</div>
						<a href={stories[0].url} class="pointer-link">Read more</a>
					</div>
				</div>

				<div class="ns-col-three">
					<div class="story-card">
						<h3>{stories[1].title}</h3>
						<div class="tiny-wrap">
							{@html stories[1].content}
						</div>
						<a href={stories[1].url} class="pointer-link">Read more</a>
					</div>
				</div>

				<!-- {#if !moveLink} -->
				<a href="/newsroom/" class="pointer-link">Newsroom</a>
				<!-- {/if} -->

			</div>
		</div>
	</div>
{/if}

<div use:moveModalToBody>
	{#if showModal}
		<Modal on:close={() => (showModal = false)} width={500}>
			<div class="modal-inner">
				{#if signupUnsuccessful}
					<h1>Signup Unsuccessful</h1>
					<p>
						While we're working on fixing this, please subscribe directly
						<a
							href="https://visitor.r20.constantcontact.com/manage/optin?v=001l3cLBhqUqd-D7guBne6dNcyUgcjzCz8T"
							target="_blank"
							rel="noopener noreferrer">
							using this form
						</a>
						.
					</p>
				{:else}
					<h1>Signup Successful</h1>
					<p>Thank you for subscribing to our newsletter!</p>
				{/if}
			</div>
		</Modal>
	{/if}
</div>
